import React from "react";
import { useTranslation } from 'react-i18next';
import "../../styles/OwnerExercises.css";

const OwnerAssignedExerciseItem = ({ exercise, expanded, toggleExpand }) => {
    const { t, i18n } = useTranslation('exercises');

    if (!exercise || !exercise.exercise) {
        return <p className="owner-no-exercises-message">{t('noExerciseData')}</p>;
    }

    const { assignedDate, completed, completionDate, exercise: exerciseDetails } = exercise;

    const difficultyMapping = {
        BASIC: t('difficulty.basic'),
        INTERMEDIATE: t('difficulty.intermediate'),
        ADVANCED: t('difficulty.advanced')
    };

    return (
        <div
            className={`owner-exercise-card ${expanded ? "owner-exercise-open" : ""} ${completed ? "owner-exercise-completed" : ""}`}
            onClick={toggleExpand}
        >
            <div className="owner-exercise-header">
                <span className="owner-exercise-name">{exerciseDetails.name}</span>
                <span className={`owner-difficulty ${exerciseDetails.difficultyLevel.toLowerCase()}`}>
                    {difficultyMapping[exerciseDetails.difficultyLevel] || exerciseDetails.difficultyLevel}
                </span>
                {/* No action buttons for owner - only display */}
            </div>

            {expanded && (
                <div className="owner-exercise-details">
                    <p><strong>{t('descriptionLabel')}:</strong><br />
                        {exerciseDetails.description}</p>
                    <p><strong>{t('equipment')}:</strong> {exerciseDetails.requiredEquipment || t('none')}</p>
                    <p><strong>{t('assignedDate')}:</strong> {new Date(assignedDate).toLocaleDateString(i18n.language)}</p>
                    {completed && (
                        <p className="owner-exercise-completion-text">
                            <strong>{t('completionDate')}:</strong> {new Date(completionDate).toLocaleDateString(i18n.language)}
                        </p>
                    )}
                </div>
            )}
        </div>
    );
};

export default OwnerAssignedExerciseItem;